export default class SimulatorQuestionNode {
    constructor(value) {
        this.value = value;
        this.prev = null;
        this.next = null;
    }
}